import { Box } from '@chakra-ui/layout'
import { } from 'containers'
import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import moment from 'momentconfig'
import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Confirmation } from '../components'
import BlackboxService from './BlackboxService'

class Blackbox extends Component {
    constructor(props) {
        super(props)

        let { blackbox } = props

        this.state = {
            colors: ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'],
            deleting: false,
            ...blackbox,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {}

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network, blackbox } = this.props

        network.deleteBlackbox(blackbox)

        this.setState({ deleting: false })
    }

    render() {
        let { type, blackbox, onClick, selected } = this.props
        let { deleting, id_blackbox, id_machine, valid, services } = this.state

        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        if (onClick) {
            extraprops.onClick = () => {
                onClick(blackbox)
            }
        }

        let col = parseInt(Math.random() * this.state.colors.length)

        switch (type) {
            default:
                return (
                    <View fullw column between>
                        <Box borderWidth="1px" borderRadius="lg"
                    p="4" overflow="hidden" className={selected ? 'rowSelected' : ''} style={styles.blackboxCard} {...extraprops} >
                            <Confirmation
                                message="Vuoi davvero eliminare questa blackbox?"
                                showModal={deleting}
                                onConfirm={() => {
                                    this.remove()
                                }}
                                onCancel={() => {
                                    this.setState({ deleting: false })
                                }}
                            />
                            <Box textStyle="content" style={styles.blackboxContent}>
                                <View fullw column>
                                    <View fullw column>
                                        <span style={styles.header}>{id_blackbox}</span>
                                        <Box textStyle="description">Machine: {id_machine}</Box>
                                        <Box textStyle="description">Valid: {valid}</Box>
                                    </View>
                                    <View fullw column>
                                        {services.map((value, index) => (
                                            <BlackboxService key={`service_${index}`} blackbox={blackbox} service={value} />
                                        ))}
                                    </View>
                                </View>
                            </Box>
                        </Box>
                    </View>
                )
        }
    }
}

const styles = {
    header: {
        fontSize: '32pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        minWidth: 200,
        minHeight: 150,
        marginRight: 28,
    },
    blackboxImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    blackboxContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    blackboxCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = () => {
    return {}
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Blackbox)))
